import { Database } from '@vuex-orm/core'
// import User from './models/User'
// import profile from './modules/user'
import Project from './models/Project'
import projects from './modules/projects'
import Contact from './models/Contact'
import contacts from './modules/contacts'
import Slab from './models/Slab'
import slabs from './modules/slabs'
import Load from './models/Load'
import loads from './modules/loads'
import Opening from './models/Opening'
import openings from './modules/openings'

const database = new Database()

// database.register(User, profile)
database.register(Project, projects)
database.register(Contact, contacts)
database.register(Slab, slabs)
database.register(Load, loads)
database.register(Opening, openings)

export default database



// WEBPACK FOOTER //
// ./src/store/database.js